import { render, staticRenderFns } from "./KnowledgeBaseCategory.vue?vue&type=template&id=04d1337a"
import script from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports